import { Component, Input, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';

@Component({
    template: `<div>This component requires extending</div>`
})
export class HintsTypesComponent implements OnChanges {
    @Input() public indicatorType: OLO.Components.MESSAGES_TYPE = 'danger'; /* for indicator */
    @Input() public messages: { [key: string]: any; } = {};
    constructor(
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.changeDetectorRef.detectChanges();
    }
}
